export default __webpack_public_path__ + "static/media/objetivo1_recorte.dd6416e9.webp";